import React from "react";
import { useTranslation } from "react-i18next";

import Wrapper from "../../../componentsAdditional/Wrapper";
import AccessForm from "../../../componentsLanding/AccessLoadboard/AccessForm/AccessForm";
import AccessCover from "../../../componentsLanding/AccessLoadboard/AccessCover/AccessCover";

const AccessLoadboard = () => {
  const { t } = useTranslation();
  return (
    <Wrapper documentTitle={t("landing.accessLoadboard.Access load board")}>
      <section id='SignIn' className='AccesLoadboardSection'>
        <AccessCover
          url='/assets/images/static/AccessLoadboardStatic.png'
          text={t("landing.accessLoadboard.Stay ahead, stay loaded—access premium shipments now!")}
        />
        <AccessForm />
      </section>
    </Wrapper>
  );
};

export default AccessLoadboard;
